<template>                    
    <form-helper>
        <div slot="form-header">
            
            <h2>Warengruppen und Types</h2>                                                
            
        </div>
        
        <div slot="form-fields">
            <types-select></types-select>
            <v-divider></v-divider>
            <warengruppen-select></warengruppen-select>
        </div>
        
        <div slot="form-commands" >

            <v-btn icon v-on:click="submitted">
                <v-icon x-large class="green--text">done</v-icon>
            </v-btn>                        


            <router-link to="/marken" exact>
                <v-btn icon>
                    <v-icon x-large class="red--text">close</v-icon>
                </v-btn>
            </router-link>

        </div>
        
        
    </form-helper>



</template>

<script>
import formHelper from '../formHelper.vue'
import typesSelect from '../shared/typesSelect.vue'
import warengruppenSelect from '../shared/warengruppenSelect.vue'

export default {
    
    components: {
        'form-helper': formHelper,   
        'types-select': typesSelect,
        'warengruppen-select':warengruppenSelect
    },
    data() {
        return {
            id: this.$route.params.id,                                      
        };
    },
    computed: {
        mk: function() {
            return this.$store.getters.marke
        },
        loading: function() {
            return this.$store.getters.loading
        },
        basePath: function() {
            return this.$axios.defaults.baseURL
        }, 
    },
    mounted(){
               
        
        this.$store.dispatch('setTypes')
        this.$store.dispatch('setWarengruppen')
       
        
           
    },
    methods: {
        submitted: function() {
                        
            this.$emit('submitted', this.mk)
        },
                
        markenlogo: function(path) {
            return this.basePath + 'storage/logos/' + path;
        },       
    }
}
    
</script>

<style>
    
    
    
</style>


// WEBPACK FOOTER //
// editMarken_3.vue?f460a382